import React, { useState, useContext } from 'react';

import { Row, Col } from 'react-bootstrap';
import { DialogConfirmation } from 'components/atomic/molecules';
import { Alert } from 'components/atomic/atoms';
import RiskTable from './RiskTable';
import RiskForm from './RiskForm';
import { deleteRisk } from '@lib/api';
import { translate } from 'components/translation/translation';
import { UserContext } from 'components/contexts/UserProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const Risk = ({ projectId, isCoordinator, isBeneficiary }) => {
	const { isOe, userAccess } = useContext(UserContext);
	const [riskData, setRiskData] = useState({});
	const [showFormModal, setShowFormModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	// const [isLoading, setIsLoading] = useState(false);
	const [showAlert, setShowAlert] = useState({
		show: false,
		message: '',
		type: '',
	});

	const queryClient = useQueryClient();
	const handleSubmitDeleteMutation = useMutation({
		mutationFn: () => deleteRisk(projectId, riskData.id),
		onSuccess: () => {
			setShowDeleteModal(false);
			queryClient.invalidateQueries({ queryKey: ['risks', projectId] });
			setRiskData({});
			setShowAlert({
				show: true,
				message: translate('common.message.deleted', 'Elemento eliminato correttamente'),
				type: 'success',
			});
		},
		onError: (error) => {
			setShowAlert({
				show: true,
				message: error.message,
				type: 'danger',
			});
		},
	});

	const handleSubmitDelete = async () => {
		setShowAlert({ show: false, message: '', type: '' });
		handleSubmitDeleteMutation.mutate();
		// setShowAlert({ show: false, message: '', type: '' });
		// setIsLoading(true);
		// setShowDeleteModal(false);

		// await deleteRisk(projectId, riskData.id)
		// 	.then(() => {
		// 		setRiskData({});
		// 		setShowAlert({
		// 			show: true,
		// 			message: translate('common.message.deleted', 'Elemento eliminato correttamente'),
		// 			type: 'success',
		// 		});
		// 	})
		// 	.catch((error) => {
		// 		setShowAlert({
		// 			show: true,
		// 			message: error.message,
		// 			type: 'danger',
		// 		});
		// 	})
		// 	.finally(() => {
		// 		setIsLoading(false);
		// 	});
	};

	return (
		<>
			{showAlert.show && (
				<Row className="pt-3">
					<Col className="col-12 p-0">
						<Alert show={showAlert.show} message={showAlert.message} variant={showAlert.type} delay={5000} />
					</Col>
				</Row>
			)}

			<RiskTable
				projectId={projectId}
				setShowAlert={setShowAlert}
				setRiskData={setRiskData}
				setShowFormModal={setShowFormModal}
				setShowDeleteModal={setShowDeleteModal}
				// setIsLoading={setIsLoading}
				// isLoading={isLoading}
				canEdit={
					isOe ||
					userAccess.isExternalAdmin ||
					(isCoordinator && userAccess.isAboveGuest) ||
					(userAccess.isAboveGuest && isBeneficiary === false)
				}
			/>
			{(userAccess.isAboveGuest || isOe || userAccess.isExternalAdmin) && (
				<DialogConfirmation
					title="Elimina"
					content={translate('common.warning.delete', 'Sei sicuro di voler eliminare questo elemento?')}
					confirmLabel={translate('common.delete', 'Elimina')}
					cancelLabel={translate('common.cancel', 'Annulla')}
					onConfirm={() => handleSubmitDelete()}
					onCancel={() => setShowDeleteModal(false)}
					show={showDeleteModal}
					onHide={() => setShowDeleteModal(false)}
				/>
			)}
			<RiskForm
				// isLoading={isLoading}
				// setIsLoading={setIsLoading}
				showFormModal={showFormModal}
				setShowFormModal={setShowFormModal}
				riskData={riskData}
				setRiskData={setRiskData}
				projectId={projectId}
				setShowAlert={setShowAlert}
				canEdit={
					isOe ||
					userAccess.isExternalAdmin ||
					(isCoordinator && userAccess.isAboveGuest) ||
					(userAccess.isAboveGuest && isBeneficiary === false)
				}
			/>
		</>
	);
};

export default Risk;
